import { nanoid } from "nanoid";
import React, { ReactNode, Suspense, useContext, useEffect, useMemo } from "react";
import { RevUserContext } from "../../context/UserContext";
import { FavoriteApi } from "../../redux/api/FavoriteApi";
import { FeedApi } from "../../redux/api/FeedApi";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { IUserProfile } from "../../types/User/IUserProfile";
import { ActivityFeed, ToolProps } from "./ActivityFeed/ActivityFeed";
import { Contacts } from "./Contacts/Contacts";
import { Revelations } from "./Revelations/Revelations";
import "./RightBar.scss";
import { ToolButton } from "./ToolButton";
import XMLParser from "react-xml-parser";
import { IContact } from "../../types/User/IContact";
import { updateToggleState } from "../../slices/RightBarSlice";
import { ChatBar } from "./Chat/ChatBar";
import ChatRequest from "../Chat/ChatRequest";
import { ErrorBoundary } from "../Common/ErrorBoundry";
import { useParams } from "react-router-dom";
import { UserApi } from "../../redux/api/UserApi";
import { Links } from "./Links/Links";

//@ts-expect-error
const ChatCount = React.lazy(() => import("chat/ChatCount").catch());
//@ts-expect-error
const PinnedChatModule = React.lazy(() => import("chat/PinnedChats").catch());
//@ts-expect-error
const ChatNotificationModule = React.lazy(() => import("chat/ChatNotification").catch());

export enum ToggleState {
  Uninitialized = 0,
  Collapsed = 1,
  Expanded = 2,
  Free = 3,
}

export const RightBar = ({ children }: { children: ReactNode }) => {
  const profile = useContext<IUserProfile>(RevUserContext);
  const locked = useReduxSelector((state) => state.rightBar.toggleState);
  //const { FeedItems, LastId } = useReduxSelector(rev => rev.feed.feedItems)
  const [lastId, setLastId] = React.useState<number>();
  //const [isLocked, setIsLocked] = React.useState<number>(locked);
  const dispatch = useReduxDispatch();
  const [selectedId, setSelectedId] = React.useState<string>();
  const [dockOrder, setDockOrder] = React.useState<string[]>();
  const { data: feedResult } = FeedApi.useGetUserFeedQuery({ uid: profile.Uid, lastId: lastId ? lastId.toString() : '' }, {
    pollingInterval: 20000,
    skip: !profile?.Features.Activity_Feed,
  });
  const { data: config } = FavoriteApi.useGetFavoriteConfigQuery(profile.Uid, { skip: profile?.Features.External_Interface });
  const [saveFavConfig] = FavoriteApi.useSaveFavoriteConfigMutation();
  const [selectedContact, setSelectedContact] = React.useState<IContact>();

  //Show the current contact from the ticket details page.
  const { contactId: ticketContactId } = useParams()
  const { data: ticketContact } = UserApi.useGetUserByIdQuery(parseInt(ticketContactId), { skip: !ticketContactId })

  useEffect(() => {
    if (ticketContact) {
      //Expand contacts
      setSelectedId("contacts");
      setSelectedContact({
        ID: ticketContact.ID,
        FullName: ticketContact.FullName,
      } as IContact);

      //console.log('ticketContact', locked, ticketContact)
      if (locked)
        dispatch(updateToggleState(ToggleState.Free))
    }
  }, [ticketContact])


  //Update the feed items in reduc state
  useEffect(() => {
    //console.log('RightBar.tsx', feedResult)
    //if (feedResult tId)
    //dispatch(FeedSlice.SetFeedItems(feedResult));
    if (feedResult && feedResult.LastId > 0 && feedResult.LastId !== lastId)
      setLastId(feedResult?.LastId)
  }, [feedResult, dispatch]);

  useEffect(() => {
    if (
      config &&
      (locked === ToggleState.Uninitialized ||
        config?.Contact_Id !== profile.Id)
    ) {
      let foundINdex = config.Page_State_Xml.indexOf(
        '<item key="0" value="True" />'
      );
      //console.log('foundINdex', foundINdex, config)
      dispatch(
        updateToggleState(
          foundINdex > -1 ? ToggleState.Expanded : ToggleState.Collapsed
        )
      );
      var dockOrder = new XMLParser().parseFromString(config.Dock_Order);
      var dockArr = dockOrder?.children?.map((c) => c?.attributes["value"])
      setDockOrder(dockArr);
      console.log('setDockOrder', dockArr)
    }
  }, [config, locked, profile.Uid, dispatch]);

  ///Listen for contact name click from CallHistory.aspx page in the IFrame
  useEffect(() => {
    //Add event listener for Events that get posted as messages in the IFrame so we can trigger things like updating the banner
    const messageListener = (e) => {
      try {
        if (e.data?.indexOf && e.data?.indexOf("{") === 0) {
          var messageObj = JSON.parse(e.data);
          //console.log('messageObj', messageObj)
          if ("message" in messageObj && messageObj.message === "ShowContact") {
            if (
              "contactId" in messageObj &&
              messageObj.contactId &&
              !isNaN(messageObj.contactId)
            ) {
              console.log("setting expanded", locked);
              //Expand contacts
              setSelectedId("contacts");

              setSelectedContact({
                ID: messageObj.contactId,
                FullName: messageObj.contactName,
              } as IContact);
              if (locked === ToggleState.Collapsed) {
                dispatch(updateToggleState(ToggleState.Free));
              }
              //setFavOnly(false);
              //setContactIdSelected(messageObj.contactId)
              //setFilter(messageObj.contactName)
            }
          }
        }
      } finally {
      }
    };

    var ev = window.addEventListener("message", messageListener, false);
    return () => {
      window.removeEventListener("message", messageListener);
    };
  }, [locked, dispatch]);

  const buttonClicked = async (id) => {
    if (locked === ToggleState.Collapsed) {
      // let newConfig = { ...config, Page_State_Xml: '<DictionaryOfStringBoolean><item key="0" value="True" /></DictionaryOfStringBoolean>' }
      // await saveFavConfig(newConfig);

      dispatch(updateToggleState(ToggleState.Free));
    } else if (locked === ToggleState.Free && selectedId === id)
      dispatch(updateToggleState(ToggleState.Collapsed));

    if (selectedId !== id) {
      //let newOrder = tools.map(t => t.id);
      //console.log('dockOrder', dockOrder)
      let newOrder = tools.map(t => t.id)
      newOrder.splice(newOrder.indexOf(id), 1);
      newOrder.unshift(id);
      console.log('newOrder', newOrder)
      //Update the order via the API
      let newOrderXML = `<DictionaryOfInt32String><item key="0" value="${newOrder[0]}" /><item key="1" value="${newOrder[1]}" /><item key="2" value="${newOrder[2]}" /><item key="3" value="${newOrder[3]}" /></DictionaryOfInt32String>`;

      setSelectedId(id);
      let newConfig = { ...config, Dock_Order: newOrderXML };
      await saveFavConfig({ config: newConfig, uid: profile.Uid });
    }
  };

  const unlockTools = async () => {
    console.log("unlockTools", config);

    dispatch(updateToggleState(ToggleState.Collapsed));
    //setIsLocked(ToggleState.Collapsed);

    let newConfig = {
      ...config,
      Page_State_Xml:
        '<DictionaryOfStringBoolean><item key="0" value="False" /></DictionaryOfStringBoolean>',
    };
    await saveFavConfig({ config: newConfig, uid: profile.Uid });
  };
  let lockingTools = false;
  const lockTools = async () => {
    lockingTools = true;
    console.log("lockTools", config);
    dispatch(updateToggleState(ToggleState.Expanded));
    //setIsLocked(ToggleState.Expanded);

    let newConfig = {
      ...config,
      Page_State_Xml:
        '<DictionaryOfStringBoolean><item key="0" value="True" /></DictionaryOfStringBoolean>',
    };
    await saveFavConfig({ config: newConfig, uid: profile.Uid });
  };

  useEffect(() => {
    console.log('useEffect locked', locked)
    //setIsLocked(locked)
  }, [locked])

  const handleMouseLeave = (e) => {
    //e.stopPropagation();
    //e.preventDefault();
    console.log('handleMouseLeave locked=', locked, lockingTools)
    if (locked === ToggleState.Free && !lockingTools) {
      dispatch(updateToggleState(ToggleState.Collapsed));
      //setIsLocked(ToggleState.Collapsed)
    }
  };

  const handleClick = (e) => {
    e && e.stopPropagation();
    e && e.preventDefault();
    console.log('handleClick locked=', locked)
    if (locked === ToggleState.Free) {
      dispatch(updateToggleState(ToggleState.Collapsed));
      //setIsLocked(ToggleState.Collapsed)
    }
  };

  const toolProps: ToolProps = {
    fullScreen: false,
    unlocked: unlockTools,
    locked: lockTools,
    itemSelected: handleClick,
    onMouseLeave: handleMouseLeave
  };
  const tools = useMemo(
    () =>
      [
        {
          id: "chat",
          imageUrl: "./images/Chat.png",
          class: "chat-button",
          element: <ChatBar {...toolProps} itemSelected={handleClick} />,
          title: "Chat",
          badge:
            <ErrorBoundary errorMessage="?">
              <ChatCount />
            </ErrorBoundary>,
          visible: profile?.Features.Chat,
          order: dockOrder?.indexOf("chat"),
        },
        {
          id: "activity",
          imageUrl: "./images/Activity-Feed-Dark.png",
          class: "feed-button",
          element: <ActivityFeed {...toolProps} feedResults={feedResult} />,
          title: "Activity feed",
          badge:
            feedResult?.UnReadCount > 0
              ? feedResult?.UnReadCount.toString()
              : null,
          visible: profile?.Features.Activity_Feed,
          order: dockOrder?.indexOf("activity"),
        },
        {
          id: "contacts",
          imageUrl: "./images/Contacts-Dark.png",
          class: "contacts-button",
          element: (
            <Contacts
              {...toolProps}
              selectedContact={selectedContact}
            />
          ),
          title: "Contacts",
          badge: null,
          visible: profile?.Features.Contacts_Dock,
          order: dockOrder?.indexOf("contacts"),
        },
        {
          id: "favorites",
          imageUrl: "./images/Revelations-Dark.png",
          class: "revelations-button",
          element: <Revelations {...toolProps} />,
          title: "Revelations",
          badge: null,
          visible: profile?.Features.Revelations,
          order: dockOrder?.indexOf("favorites"),
        },
        {
          id: "links",
          imageUrl: "./images/Link-Out.png",
          class: "links-button",
          element: <Links {...toolProps} />,
          title: "Links",
          badge: null,
          visible: profile?.Features.Link_Out,
          order: dockOrder?.indexOf("links"),
        },
      ].sort((x, y) => x.order - y.order),
    [feedResult, profile, dockOrder, config, selectedContact, dispatch]
  );

  //console.log('tools', tools);

  const toolsClass = `right-bar ${tools.filter((t) => t.visible).length === 1 ? "one-tool" : ""
    }`;

  //SSI
  if (profile?.Features.External_Interface)
    return (
      <section
        className={toolsClass}
        style={{ backgroundColor: profile.Body_Hex_Color }}
      >
        <main>{children}</main>
        <Suspense fallback={<></>}>
          <ChatRequest />
        </Suspense>
      </section>)

  //Support staff
  return (
    <section
      className={toolsClass}
    // style={{ backgroundColor: halfNavcolor }}
    >
      {tools.find((t) => t.visible) && (
        <div
          className={
            locked === ToggleState.Expanded
              ? "tools"
              : locked === ToggleState.Free
                ? "tools-free"
                : "tools-hidden"
          }
        >
          <div
            className="menu"
          // style={{ backgroundColor: profile.Body_Hex_Color }}
          >
            {tools
              .filter((t) => t.visible)
              .map((t, i) => {
                return (
                  <ToolButton
                    {...t}
                    onClick={buttonClicked}
                    selected={selectedId === t.id || (!selectedId && i === 0)}
                    key={nanoid()}
                  />
                );
              })}
          </div>
          <ErrorBoundary>
            <Suspense fallback={''}>
              <ChatNotificationModule pinChatOnClick={true} />
              <PinnedChatModule />
            </Suspense>
          </ErrorBoundary>
          {locked !== ToggleState.Collapsed &&
            tools.find((t) => t.visible && (!selectedId || selectedId === t.id))
              .element}
        </div>
      )}
      <main>{children}</main>
    </section>
  );
};

